var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTowel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "towel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.775,
    height: 27.775,
    viewBox: "0 0 27.775 27.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M56,283.473H70.879v-3.388a2.037,2.037,0,0,0-.53.313,2.505,2.505,0,0,1-3.242,0,1.525,1.525,0,0,0-2.052,0,2.5,2.5,0,0,1-3.239,0,1.52,1.52,0,0,0-2.048,0,2.5,2.5,0,0,1-3.24,0,2.022,2.022,0,0,0-.528-.313Zm0,0",
    transform: "translate(-52.528 -262.642)",
    fill: "#9b9b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M56,249.04a2.573,2.573,0,0,1,1.124.549,1.52,1.52,0,0,0,2.048,0,2.5,2.5,0,0,1,3.239,0,1.521,1.521,0,0,0,2.049,0,2.5,2.5,0,0,1,3.242,0,1.525,1.525,0,0,0,2.052,0,2.572,2.572,0,0,1,1.125-.549v-.955a2.037,2.037,0,0,0-.53.313,2.505,2.505,0,0,1-3.242,0,1.525,1.525,0,0,0-2.052,0,2.5,2.5,0,0,1-3.239,0,1.52,1.52,0,0,0-2.048,0,2.5,2.5,0,0,1-3.24,0,2.023,2.023,0,0,0-.528-.313Zm0,0",
    transform: "translate(-52.528 -232.626)",
    fill: "#9b9b9b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M56,14.43a2.573,2.573,0,0,1,1.124.549,1.52,1.52,0,0,0,2.048,0,2.5,2.5,0,0,1,3.239,0,1.521,1.521,0,0,0,2.049,0,2.5,2.5,0,0,1,3.242,0,1.525,1.525,0,0,0,2.052,0,2.572,2.572,0,0,1,1.125-.549V2.48a4.776,4.776,0,0,1,.086-.758c.006-.027.015-.054.021-.08s.017-.066.026-.1c.017-.062.036-.124.056-.184s.042-.115.064-.172c.014-.036.028-.071.044-.107A3.437,3.437,0,0,1,71.918,0H58.48A2.483,2.483,0,0,0,56,2.48Zm0,0",
    transform: "translate(-52.528 0)",
    fill: "#9b9b9b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M166.879,72h-4.96V88.863a.5.5,0,0,1-.5.5H152v3.968h10.415a.5.5,0,1,1,0,.992H152v.992h14.879Zm-1.488,22.319H164.4a.5.5,0,0,1,0-.992h.992a.5.5,0,1,1,0,.992Zm0,0",
    transform: "translate(-142.576 -67.536)",
    fill: "#9b9b9b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M.5,40.992H2.48V40H.5a.5.5,0,0,0-.5.5.475.475,0,0,0,.143.344A.483.483,0,0,0,.5,40.992Zm0,0",
    transform: "translate(0 -37.52)",
    fill: "#9b9b9b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M317.66,0a2.446,2.446,0,0,0-.454.046c-.037.006-.073.016-.109.024a2.518,2.518,0,0,0-.355.111l-.067.026a2.5,2.5,0,0,0-.753.509l-.029.03a2.5,2.5,0,0,0-.267.324c-.009.013-.019.025-.028.039a2.479,2.479,0,0,0-.206.379h4.545a2.418,2.418,0,0,0-.521-.758A2.448,2.448,0,0,0,317.66,0Zm0,0",
    transform: "translate(-295.837 0)",
    fill: "#9b9b9b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M320.432,40.5a.475.475,0,0,0-.143-.344.482.482,0,0,0-.353-.152H312v.992h7.936A.5.5,0,0,0,320.432,40.5Zm0,0",
    transform: "translate(-292.657 -37.52)",
    fill: "#9b9b9b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowel);
export default __webpack_public_path__ + "static/media/towel.ebaf0ac05831365dfa25dfe7f4302dc1.svg";
export { ForwardRef as ReactComponent };